/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import classNames from 'classnames';
import { t } from 'utils/translates';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

import {
  dataRequest,
  selectRequestsStateById,
  selectItemById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

const tasksGeoTargetAccessesCollectionRN =
  'tasksModule.collections.tasksGeoTargetAccessesCollection';

// eslint-disable-next-line react/prefer-stateless-function
class GeoTargetIsAccessPopUp extends Component {
  componentDidMount() {
    if (!this.props.checkAccessMessage) {
      this.props.checkAccess();
    }
  }

  render() {
    let result;
    if (
      !this.props.checkAccessMessage ||
      this.props.checkAccessRequestState.requestInProcess
    ) {
      result = <MediumPreLoader />;
    } else {
      result = (
        <div
          className={classNames({
            'text-success': this.props.checkAccessMessage.success,
            'text-danger': !this.props.checkAccessMessage.success
          })}
        >
          {this.props.checkAccessMessage.message}
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="modal-dialog modal-gray modal-sm">
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                aria-label="Close"
                className="close close-black"
                data-dismiss="modal"
                href=""
              />
              <i className="fa fa-globe modal-icon" />
              <h4 className="modal-title">
                <strong>{t('Геотаргетинг')}</strong>
              </h4>
            </div>
            <div className="modal-body">{result}</div>
            <div className="modal-footer">
              <a
                className="btn btn-muted"
                data-dismiss="modal"
                href=""
                type="button"
              >
                {t('Закрыть')}
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

GeoTargetIsAccessPopUp.defaultProps = {
  checkAccessMessage: null
};

GeoTargetIsAccessPopUp.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  id: PropTypes.string.isRequired,

  // CONNECT
  checkAccess: PropTypes.func.isRequired,
  checkAccessRequestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  checkAccessMessage: PropTypes.shape({
    message: PropTypes.string.isRequired,
    success: PropTypes.bool.isRequired
  })
};

const mapStateToProps = (state, props) => ({
  checkAccessRequestState: selectRequestsStateById(
    state,
    tasksGeoTargetAccessesCollectionRN,
    props.id
  ),
  checkAccessMessage: selectItemById(
    state,
    tasksGeoTargetAccessesCollectionRN,
    props.id
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  checkAccess: () =>
    dispatch(dataRequest(tasksGeoTargetAccessesCollectionRN, props.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GeoTargetIsAccessPopUp)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/CheckGeotargetAccess/GeoTargetIsAccessPopUp/GeoTargetIsAccessPopUp.js